module.exports = __webpack_public_path__ + "static/media/sha4.af0140f6.webp";